import React from "react";

export default function IconEdit() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9962 6.21081L6.35355 13.8535C6.25979 13.9473 6.13261 13.9999 6 13.9999H3C3 13.9999 2.58579 13.9999 2.29289 13.7071C2.29289 13.7071 2 13.4142 2 12.9999L2 10.2062C2 10.2062 1.99931 10.01 2.07451 9.82692C2.07451 9.82692 2.14971 9.64382 2.28932 9.50352L9.7902 2.00264C9.7902 2.00264 9.92847 1.86222 10.1138 1.78462C10.1138 1.78462 10.2991 1.70703 10.5 1.70703C10.5 1.70703 10.7009 1.70703 10.8862 1.78462C10.8862 1.78462 11.0715 1.86222 11.2125 2.00536L13.9973 4.79014C13.9973 4.79014 14.1377 4.92842 14.2153 5.11373C14.2153 5.11373 14.2929 5.29904 14.2929 5.49995C14.2929 5.49995 14.2929 5.70085 14.2153 5.88616C14.2153 5.88616 14.1385 6.06971 13.9973 6.20975L13.9962 6.21081ZM13.2929 5.49995L13.2902 5.49725L10.5 2.70703L10.4973 2.70975L3 10.207V12.9999H5.79289L13.2902 5.50264L13.2929 5.49995Z"
        fill="#1C1C1C"
      />
      <path
        d="M11.6462 7.85329C11.74 7.94706 11.8674 8 12 8C12.1326 8 12.2598 7.94732 12.3535 7.85355C12.4473 7.75979 12.5 7.63261 12.5 7.5C12.5 7.36739 12.4473 7.24021 12.3535 7.14645L8.85361 3.64651C8.75978 3.55268 8.6326 3.5 8.49999 3.5C8.36739 3.5 8.24021 3.55268 8.14644 3.64645C8.05267 3.74021 7.99999 3.86739 7.99999 4C7.99999 4.13261 8.05267 4.25979 8.14644 4.35355L11.6462 7.85329Z"
        fill="#1C1C1C"
      />
      <path
        d="M2.8848 9.6777C2.79103 9.58393 2.66385 9.53125 2.53124 9.53125C2.39864 9.53125 2.27146 9.58393 2.17769 9.6777C2.08392 9.77146 2.03124 9.89864 2.03124 10.0312C2.03124 10.1639 2.08392 10.291 2.17769 10.3848L5.64644 13.8536C5.74021 13.9473 5.86739 13.9999 6 13.9999L13.5 14C13.7761 14 14 13.7761 14 13.5C14 13.2239 13.7761 13 13.5 13H6.2071L2.8848 9.6777Z"
        fill="#1C1C1C"
      />
      <path
        d="M10.6034 6.10374C10.6971 6.00997 10.75 5.88261 10.75 5.75C10.75 5.61739 10.6973 5.49021 10.6035 5.39645L10.5992 5.39218C10.5059 5.3012 10.3804 5.25 10.25 5.25C10.235 5.25 10.22 5.25067 10.2051 5.25202C10.0885 5.26254 9.97923 5.31365 9.89644 5.39645L3.89663 11.3963C3.80286 11.49 3.74999 11.6174 3.74999 11.75C3.74999 11.758 3.75019 11.766 3.75057 11.774C3.75654 11.8982 3.80855 12.0157 3.89644 12.1036C3.99021 12.1973 4.11739 12.25 4.24999 12.25C4.3826 12.25 4.50978 12.1973 4.60355 12.1036L10.6034 6.10374Z"
        fill="#1C1C1C"
      />
    </svg>
  );
}
